import { render, staticRenderFns } from "./sidebarRightSide_joints.vue?vue&type=template&id=05a276ad&scoped=true&"
import script from "./sidebarRightSide_joints.vue?vue&type=script&lang=js&"
export * from "./sidebarRightSide_joints.vue?vue&type=script&lang=js&"
import style0 from "./sidebarRightSide_joints.vue?vue&type=style&index=0&id=05a276ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a276ad",
  null
  
)

export default component.exports